import { useState, useEffect } from 'react';
import MultipleSelectList from './Default/MultipleSelectList.jsx';
import citiesData from "../data/cities.json";

export default function CitySelect({ inputClass, value, setValue, required = true }) {
    const [cityOptions, setCityOptions] = useState([]);

    useEffect(() => {
        const options = citiesData
            .filter((item) => typeof item === "string" && item.trim() !== "")
            .map((item) => ({ value: item, label: item }));

        // Сортировка по label, лексикографически, игнорируя регистр
        const sortedOptions = options.sort((a, b) =>
            a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
        );
        setCityOptions(sortedOptions);
    }, []);


    return (
        <div className={inputClass}>
            <MultipleSelectList
                options={cityOptions}
                value={value}
                setValue={setValue}
                className={inputClass}
                defaultText="Выберите город..."
            />
        </div>
    )
}